import {createSlice} from '@reduxjs/toolkit';

import storageService from '@/services/storage/storageService';

const getInitialState = () => {
    return {
        codentify: storageService.getSelectedDeviceCodentifyFromLocalStorage(),
        data: undefined,
        holderData: undefined,
        connectedData: undefined,
        connectedHolderData: undefined,
        isDataLoading: false,
        isHolderConnectedToIot: false,
        isDeviceConnectedToIot: false,
        isHolderConnectingToIot: false,
        isDeviceConnectingToIot: false,
        isDeviceWebSocketDisconnected: false,
        isHolderWebSocketDisconnected: false,
    };
};

export const slice = createSlice({
    name: 'device',
    initialState: getInitialState(),
    reducers: {
        setDeviceCodentify: (state, action) => {
            return {
                ...state,
                codentify: action.payload,
                data: undefined,
                holderData: undefined,
            };
        },
        updateDeviceCodentify: (state, action) => {
            return {
                ...state,
                codentify: action.payload,
            };
        },
        setHolderData: (state, action) => {
            return {
                ...state,
                holderData: action.payload,
            };
        },
        setDeviceData: (state, action) => {
            return {
                ...state,
                data: action.payload,
            };
        },
        updateConnectedDeviceData: (state, action) => {
            const curData = state.connectedData || {};
            const curDeviceData = curData.device || {};
            const newData = action.payload;

            return {
                ...state,
                connectedData: {...curData, ...newData, device: {...curDeviceData, ...newData.device}},
            };
        },
        updateConnectedHolderData: (state, action) => {
            const curData = state.connectedHolderData || {};
            const curDeviceData = curData.device || {};
            const newData = action.payload;

            return {
                ...state,
                connectedHolderData: {...curData, ...newData, device: {...curDeviceData, ...newData.device}},
            };
        },
        clearDeviceData: (state) => {
            return {
                ...state,
                connectedData: undefined,
                connectedHolderData: undefined,
                isDeviceConnectedToIot: false,
                isHolderConnectedToIot: false,
            };
        },
        clearHolderData: (state) => {
            return {
                ...state,
                holderData: undefined,
                isHolderConnectedToIot: false,
            };
        },
        setIsDataLoading: (state, action) => {
            return {
                ...state,
                isDataLoading: action.payload,
            };
        },
        setIsHolderConnectedToIot: (state, action) => {
            return {
                ...state,
                isHolderConnectedToIot: action.payload,
            };
        },
        setIsDeviceConnectedToIot: (state, action) => {
            return {
                ...state,
                isDeviceConnectedToIot: action.payload,
            };
        },
        setIsDeviceWebSocketDisconnected: (state, action) => {
            return {
                ...state,
                isDeviceWebSocketDisconnected: action.payload,
            };
        },
        setIsHolderWebSocketDisconnected: (state, action) => {
            return {
                ...state,
                isHolderWebSocketDisconnected: action.payload,
            };
        },
        setConnectingToIot: (state, action) => {
            const {isHolder, value} = action.payload;
            const newState = isHolder ? {isHolderConnectingToIot: value} : {isDeviceConnectingToIot: value};

            return {
                ...state,
                ...newState,
            };
        },
        updateDeviceSettingState: (state, action) => {
            const isHolder = action.payload.isHolder;
            const deviceData = action.payload.deviceData;
            const currentData = (isHolder ? state.connectedHolderData : state.connectedData) || {};

            //should be updated only device data not a whole data
            const newDeviceData = currentData.device ? {...currentData.device, ...deviceData} : deviceData;
            const newData = {...currentData, ...{device: newDeviceData}};
            const newState = isHolder ? {connectedHolderData: newData} : {connectedData: newData};

            return {
                ...state,
                ...newState,
            };
        },
    },
});

export const {
    clearDeviceData,
    clearHolderData,
    setDeviceCodentify,
    setDeviceData,
    setHolderData,
    updateConnectedDeviceData,
    updateConnectedHolderData,
    setIsDataLoading,
    setIsDeviceConnectedToIot,
    setIsHolderConnectedToIot,
    setIsDeviceWebSocketDisconnected,
    setIsHolderWebSocketDisconnected,
    setConnectingToIot,
    updateDeviceSettingState,
    updateDeviceCodentify,
} = slice.actions;

export default slice.reducer;
